/* bundle-builder.js
   Vanilla JS bundle builder for Motto theme
   - Listens for .btn--add-to-set clicks
   - Shows a slide-out modal, tracks selections (max 25)
   - Adds items to cart by fetching product JSON to get a variant id
   - Stores bundle product ids in cart.attributes.bundle_build
   - Lightweight, dependency-free, production-ready

   Tweaks:
   - Inline error UX (no alerts), restores button state
   - Collapsed toggle button "build your set (N)"
   - Do not open overlay when empty; hide backdrop when empty
*/

(function () {
  if (window.__bundleBuilderLoaded) return;
  window.__bundleBuilderLoaded = true;

  // CONFIG
  const MAX_ITEMS = 25;
  const CURRENCY_SYMBOL = null; // set to '€' or '$' to force symbol
  const LS_KEY = 'bb_set_v1';
  const scriptEl = document.currentScript || document.querySelector('script[src*="bundle-builder.js"]');
  const DELETE_ICON_SRC = window.__bundleBuilderDeleteIcon || (scriptEl ? new URL('delete-icon-30px.svg', scriptEl.src).toString() : '/assets/delete-icon-30px.svg');

  // Simple discount codes to apply via URL redirect after add-to-cart
  // Assumption: these codes exist in Shopify as percentage discounts
  const DISCOUNT_3_ITEMS = 'CITYGUIDE20'; // 20% for 3-4 items
  const DISCOUNT_5_ITEMS = 'CITYGUIDE30'; // 30% for 5+ items

  function getDiscountForCount(count) {
    if (count >= 5) return { percent: 30, code: DISCOUNT_5_ITEMS };
    if (count >= 3) return { percent: 20, code: DISCOUNT_3_ITEMS };
    return { percent: 0, code: null };
  }

  // Simple money formatter
  function formatMoney(number) {
    const n = Number(number) || 0;
    if (CURRENCY_SYMBOL) return CURRENCY_SYMBOL + n.toFixed(2);
    try {
      return new Intl.NumberFormat(navigator.language || 'en-US', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  // Escape to avoid XSS when inserting innerHTML fragments
  function esc(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Persist helpers
  function loadFromStorage() {
    try {
      const raw = localStorage.getItem(LS_KEY);
    if (!raw) return [];
      const arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return [];
      // sanitize
      return arr
        .filter(it => it && it.id)
        .map(it => ({
          id: String(it.id),
          title: typeof it.title === 'string' ? it.title : 'Product',
          url: typeof it.url === 'string' ? it.url : '#',
          price: Number(it.price) || 0,
      image: typeof it.image === 'string' ? it.image : null,
      imageAlt: typeof it.imageAlt === 'string' ? it.imageAlt : ''
        }));
    } catch (_) {
      return [];
    }
  }
  function saveToStorage(items) {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify(items || state.items));
    } catch (_) {
      // no-op
    }
  }
  function clearStorage() {
    try { localStorage.removeItem(LS_KEY); } catch (_) {}
  }

  function removeProductFromSet(productId) {
    if (!productId) return;
    const idx = state.items.findIndex(item => String(item.id) === String(productId));
    if (idx === -1) return;
    state.items.splice(idx, 1);
    saveToStorage();
    renderList();
  }

  // State
  const state = {
    items: [] // { id, title, url, price (number) }
  };
  let hiddenByCart = false;
  let cartDrawerObserver = null;

  // Root mount must exist in layout: <div id="bundle-builder-root"></div>
  function getRoot() {
    return document.getElementById('bundle-builder-root');
  }

  // Inline error helpers
  function showError(msg, { persistent = false } = {}) {
    const el = document.getElementById('bb-error');
    if (!el) return;
    el.textContent = msg || 'Something went wrong.';
    el.classList.add('bb-error--visible');
    if (!persistent) {
      clearTimeout(el._bbTimer);
      el._bbTimer = setTimeout(() => clearError(), 5000);
    }
  }
  function clearError() {
    const el = document.getElementById('bb-error');
    if (!el) return;
    el.classList.remove('bb-error--visible');
    el.textContent = '';
  }
  function updateToggleLabel() {
    const t = document.getElementById('bb-toggle');
    if (t) t.textContent = `City Guide Set (${state.items.length})`;
  }
  function updateBackdropVisibility() {
    const backdrop = document.querySelector('#bb-overlay .bb-backdrop');
    if (!backdrop) return;
    backdrop.style.display = state.items.length === 0 ? 'none' : '';
  }

  function isOverlayOpen() {
    const overlay = document.getElementById('bb-overlay');
    return !!(overlay && overlay.classList.contains('bb-open') && !overlay.classList.contains('bb-hidden'));
  }

  // Show the floating toggle only when at least 1 item is in the set
  function updateToggleVisibility() {
    const t = document.getElementById('bb-toggle');
    if (!t) return;
    const hasItems = state.items.length > 0;
    const shouldShow = hasItems && !hiddenByCart && !isOverlayOpen();
    const wasHidden = t.hidden;

    if (shouldShow) {
      t.hidden = false;
      t.setAttribute('aria-hidden', 'false');

      if (wasHidden) {
        requestAnimationFrame(() => {
          t.classList.add('bb-animate-in');
          setTimeout(() => {
            t.classList.add('bb-pulse');
            setTimeout(() => {
              t.classList.remove('bb-pulse');
            }, 3000);
          }, 400);
        });
      }
    } else {
      t.hidden = true;
      t.setAttribute('aria-hidden', 'true');
      t.classList.remove('bb-animate-in', 'bb-pulse');
    }
  }

  // Fetch product JSON and return preferred small image (2nd image if available)
  async function fetchProductThumb(productUrl) {
    try {
      const resp = await fetch((productUrl || '').replace(/\/$/, '') + '.js', { credentials: 'same-origin' });
      if (!resp.ok) return { src: null, alt: '' };
      const prod = await resp.json();
      const imgs = Array.isArray(prod && prod.images) ? prod.images : [];
      const srcRaw = imgs[1] || imgs[0] || null; // prefer 2nd
      if (!srcRaw) return { src: null, alt: '' };
      // Add a small width param for thumb
      const u = new URL(srcRaw, window.location.origin);
      if (!u.searchParams.has('width')) u.searchParams.set('width', '120');
      return { src: u.toString(), alt: (prod && prod.title) || '' };
    } catch (_) {
      return { src: null, alt: '' };
    }
  }

  // Build modal markup and inject into #bundle-builder-root
  function ensureModal() {
    const root = getRoot();
    if (!root) return console.warn('bundle-builder: missing #bundle-builder-root');
    if (root.dataset.bbInitialized === '1') return;

    root.innerHTML = `
      <button id="bb-toggle" class="bb-toggle" aria-controls="bb-overlay" aria-expanded="false" aria-hidden="true" hidden>Trip map set (0)</button>
      <div id="bb-overlay" class="bb-hidden" role="dialog" aria-modal="true" aria-label="Build your set" aria-hidden="true">
        <div class="bb-backdrop" data-bb-close></div>
        <aside class="bb-panel" role="document" aria-labelledby="bb-title">
          <header class="bb-header">
            <div class="bb-heading-group">
              <h2 id="bb-title">Bundle &amp; Save on City Guides</h2>
              <h4 id="bb-subtitle">Buy 3 guides to get 20% off — or 5 guides to unlock 30% off.</h4>
            </div>
            <button class="bb-close" data-bb-close aria-label="Close">×</button>
          </header>
          <main class="bb-main">
            <div id="bb-list" class="bb-list"></div>
          </main>
          <footer class="bb-footer">
            <div id="bb-error" class="bb-error" role="alert" aria-live="assertive" aria-atomic="true"></div>
            <div class="bb-summary">
              <span id="bb-count" class="visually-hidden"></span>
              <div class="bb-summary__row">
                <span class="bb-summary__label">Subtotal</span>
                <span id="bb-subtotal" class="bb-summary__value bb-summary__subtotal">${formatMoney(0)}</span>
              </div>
              <div id="bb-discount-row" class="bb-summary__row bb-summary__discount" hidden>
                <div class="bb-summary__label-group">
                  <span class="bb-summary__label">Discount</span>
                  <span id="bb-discount-text" class="bb-discount-note__text"></span>
                </div>
                <span id="bb-discount-amount" class="bb-summary__value bb-discount-note__amount"></span>
              </div>
              <div class="bb-summary__row bb-summary__total">
                <span class="bb-summary__label">Total</span>
                <span id="bb-total" class="bb-summary__value bb-summary__total-value">${formatMoney(0)}</span>
              </div>
            </div>
            <div class="bb-actions">
              <button id="bb-clear" class="bb-btn">Clear</button>
              <button id="bb-add-cart" class="bb-btn bb-primary">Add to cart</button>
            </div>
          </footer>
        </aside>
      </div>
    `;

    // Ensure root itself is never aria-hidden (prevents focus-in-hidden warnings)
    root.removeAttribute('aria-hidden');

    // attach handlers
    root.querySelectorAll('[data-bb-close]').forEach(el => {
      el.addEventListener('click', closeModal);
    });
    root.querySelector('#bb-clear').addEventListener('click', () => {
      state.items = [];
      saveToStorage();
      renderList(); // will auto-close overlay when empty
    });
    root.querySelector('#bb-add-cart').addEventListener('click', onAddToCart);

    // Toggle collapsed/expanded
    root.querySelector('#bb-toggle').addEventListener('click', () => {
      if (state.items.length === 0) {
        updateToggleLabel();
        updateBackdropVisibility();
        return;
      }
      const overlay = document.getElementById('bb-overlay');
      if (!overlay) return;
      if (overlay.classList.contains('bb-hidden')) openModal(); else closeModal();
    });

    root.dataset.bbInitialized = '1';
  // Sync initial visibility/label state
  updateToggleLabel();
  updateToggleVisibility();
    updateButtonStates();
    if (hiddenByCart) {
      root.style.display = 'none';
    }
  }

  // Render list content into modal
  function renderList() {
    const listEl = document.getElementById('bb-list');
  const countEl = document.getElementById('bb-count');
  const subtotalEl = document.getElementById('bb-subtotal');
  const totalEl = document.getElementById('bb-total');
  const discountNoteTextEl = document.getElementById('bb-discount-text');
  const discountNoteAmountEl = document.getElementById('bb-discount-amount');
  const discountRowEl = document.getElementById('bb-discount-row');
    const overlay = document.getElementById('bb-overlay');

  if (!listEl || !countEl || !totalEl) {
    updateToggleLabel();
    updateBackdropVisibility();
    updateToggleVisibility();
    updateButtonStates();
    return;
  }

    listEl.innerHTML = '';

    if (state.items.length === 0) {
      listEl.innerHTML = '<p class="bb-empty">Choose products from the page to add to your set.</p>';
    } else {
  state.items.forEach((it, idx) => {
        const row = document.createElement('div');
        row.className = 'bb-item';
        row.innerHTML = `
          <div class="bb-item-left">
    ${it.image ? `<img class=\"bb-item-thumb\" src=\"${esc(it.image)}\" alt=\"${esc(it.imageAlt || it.title)}\" loading=\"lazy\">` : ''}
    <a href="${esc(it.url)}" class="bb-item-title">${esc(it.title)}</a>
          </div>
          <div class="bb-item-right">
            <div class="bb-item-price">${formatMoney(it.price)}</div>
            <div class="bb-item-actions">
              <button class="bb-remove" data-idx="${idx}" aria-label="Remove ${esc(it.title)}">
                <img src="${esc(DELETE_ICON_SRC)}" class="bb-remove-icon" alt="" aria-hidden="true">
                <span class="visually-hidden">Remove ${esc(it.title)}</span>
              </button>
            </div>
          </div>
        `;
        listEl.appendChild(row);
      });

      // attach remove handlers
      listEl.querySelectorAll('.bb-remove').forEach(btn => {
        btn.addEventListener('click', () => {
          const idx = Number(btn.getAttribute('data-idx'));
          if (!Number.isNaN(idx)) {
            state.items.splice(idx, 1);
            saveToStorage();
            renderList();
          }
        });
      });
    }

    const count = state.items.length;
    countEl.textContent = count;
    const subtotal = state.items.reduce((s, i) => s + Number(i.price || 0), 0);
    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    const { percent, code } = getDiscountForCount(count);
    const discountedTotal = percent > 0 ? subtotal * (1 - percent / 100) : subtotal;
    const discountAmount = Math.max(0, subtotal - discountedTotal);
    totalEl.textContent = formatMoney(discountedTotal);
    if (percent > 0) {
      if (discountNoteTextEl) {
        discountNoteTextEl.textContent = `${percent}% off - Bundle & Save Discount`;
      }
      if (discountNoteAmountEl) {
        discountNoteAmountEl.textContent = `${formatMoney(discountAmount)}`;
      }
      if (discountRowEl) discountRowEl.hidden = false;
    } else {
      if (discountNoteTextEl) discountNoteTextEl.textContent = '';
      if (discountNoteAmountEl) discountNoteAmountEl.textContent = '';
      if (discountRowEl) discountRowEl.hidden = true;
    }

    // Update UI bits
    updateToggleLabel();
    updateBackdropVisibility();
  updateToggleVisibility();
    updateButtonStates();

    // If empty and overlay currently open, close it
    if (state.items.length === 0 && overlay && !overlay.classList.contains('bb-hidden')) {
      closeModal();
    }
  }

  // Show/hide modal
  let lastFocused = null;

  function openModal() {
    ensureModal();
    if (state.items.length === 0) return; // don't open when empty
    const overlay = document.getElementById('bb-overlay');
    const toggle = document.getElementById('bb-toggle');
    const root = getRoot();
    if (!overlay) return;
    if (root) root.removeAttribute('aria-hidden');
    overlay.classList.remove('bb-hidden');
    overlay.classList.add('bb-open');
    overlay.removeAttribute('inert');
    overlay.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    clearError();
    renderList();
    trapFocus(true);
  }

  function closeModal() {
    const overlay = document.getElementById('bb-overlay');
    const toggle = document.getElementById('bb-toggle');
    if (!overlay) return;
    // If focus is currently inside the overlay, blur before hiding to avoid aria-hidden warnings
    if (overlay.contains(document.activeElement)) {
      try { document.activeElement.blur(); } catch (_) {}
    }
    overlay.classList.add('bb-hidden');
    overlay.classList.remove('bb-open');
    overlay.setAttribute('inert', '');
    overlay.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    trapFocus(false);
    updateToggleVisibility();
  }

  function setBundleHiddenByCart(isHidden) {
    hiddenByCart = !!isHidden;
    const root = getRoot();
    if (!root) return;
    if (hiddenByCart) {
      closeModal();
      root.style.display = 'none';
    } else {
      root.style.display = '';
      updateToggleVisibility();
    }
  }

  // Focus trap minimal implementation when modal open
  function trapFocus(enable) {
    const overlay = document.getElementById('bb-overlay');
    if (!overlay) return;
    if (enable) {
      lastFocused = document.activeElement;
      const firstFocusable = overlay.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
      document.addEventListener('keydown', handleKeyDown);
    } else {
      document.removeEventListener('keydown', handleKeyDown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }
  }
  function handleKeyDown(e) {
    if (e.key === 'Escape') closeModal();
    if (e.key === 'Tab') {
      const overlay = document.getElementById('bb-overlay');
      const focusables = overlay ? Array.from(overlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(el => !el.disabled) : [];
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    }
  }

  // Update button states based on current bundle contents
  function updateButtonStates() {
    document.querySelectorAll('.btn--add-to-set').forEach(btn => {
      const productId = btn.getAttribute('data-product-id');
      const isInBundle = state.items.some(item => String(item.id) === String(productId));
      
  let removeBtn = null;
  const controls = btn.closest('.bb-card-controls');
  if (controls) removeBtn = controls.querySelector('.bb-remove-inline');

      if (isInBundle) {
        btn.classList.add('bb-added');
        btn.setAttribute('aria-label', btn.getAttribute('data-product-title') + ' added to set');
        // Update icon to checkmark
        const icon = btn.querySelector('.bb-icon');
        if (icon) {
          icon.innerHTML = '<path d="M20.285 6.708a1 1 0 0 1 0 1.414L10.293 18.122a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414l4.293 4.293 9.285-9.293a1 1 0 0 1 1.414 0z" fill="currentColor"/>';
        }
        // Update label
        const label = btn.querySelector('.bb-label');
        if (label) {
          label.textContent = 'Added to set';
        }
        if (removeBtn) {
          removeBtn.classList.add('bb-visible');
          removeBtn.setAttribute('aria-hidden', 'false');
          removeBtn.setAttribute('data-product-id', productId);
          removeBtn.setAttribute('aria-label', 'Remove ' + btn.getAttribute('data-product-title') + ' from set');
        }
      } else {
        btn.classList.remove('bb-added');
        btn.setAttribute('aria-label', 'Add ' + btn.getAttribute('data-product-title') + ' to set');
        // Update icon back to layers
        const icon = btn.querySelector('.bb-icon');
        if (icon) {
          icon.innerHTML = '<path fill-rule="evenodd" clip-rule="evenodd" d="M12 4.75C10.9396 4.75 10.0907 5.07796 8.06584 5.88789L5.25737 7.01128C4.24694 7.41545 3.54677 7.69659 3.09295 7.93451C3.0486 7.95776 3.00863 7.97959 2.97267 8C3.00863 8.02041 3.0486 8.04224 3.09295 8.06549C3.54677 8.30341 4.24694 8.58455 5.25737 8.98872L8.06584 10.1121C10.0907 10.922 10.9396 11.25 12 11.25C13.0604 11.25 13.9093 10.922 15.9342 10.1121L18.7426 8.98872C19.7531 8.58455 20.4532 8.30341 20.9071 8.06549C20.9514 8.04224 20.9914 8.02041 21.0273 8C20.9914 7.97959 20.9514 7.95776 20.9071 7.93451C20.4532 7.69659 19.7531 7.41545 18.7426 7.01128L15.9342 5.88789C13.9093 5.07796 13.0604 4.75 12 4.75ZM7.62442 4.4489C9.50121 3.69796 10.6208 3.25 12 3.25C13.3792 3.25 14.4988 3.69796 16.3756 4.4489C16.4138 4.4642 16.4524 4.47962 16.4912 4.49517L19.3451 5.6367C20.2996 6.01851 21.0728 6.32776 21.6035 6.60601C21.8721 6.74683 22.1323 6.90648 22.333 7.09894C22.5392 7.29668 22.75 7.59658 22.75 8C22.75 8.40342 22.5392 8.70332 22.333 8.90106C22.1323 9.09352 21.8721 9.25317 21.6035 9.39399C21.2519 9.57835 20.7938 9.77632 20.247 10C20.7938 10.2237 21.2519 10.4216 21.6035 10.606C21.8721 10.7468 22.1323 10.9065 22.333 11.0989C22.5392 11.2967 22.75 11.5966 22.75 12C22.75 12.4034 22.5392 12.7033 22.333 12.9011C22.1323 13.0935 21.8721 13.2532 21.6035 13.394C21.2519 13.5784 20.7938 13.7763 20.247 14C20.7938 14.2237 21.2519 14.4216 21.6035 14.606C21.8721 14.7468 22.1323 14.9065 22.333 15.0989C22.5392 15.2967 22.75 15.5966 22.75 16C22.75 16.4034 22.5392 16.7033 22.333 16.9011C22.1323 17.0935 21.8721 17.2532 21.6035 17.394C21.0728 17.6722 20.2997 17.9815 19.3451 18.3633L16.4912 19.5048C16.4524 19.5204 16.4138 19.5358 16.3756 19.5511C14.4988 20.302 13.3792 20.75 12 20.75C10.6208 20.75 9.50121 20.302 7.62443 19.5511C7.58619 19.5358 7.54763 19.5204 7.50875 19.5048L4.6549 18.3633C3.70034 17.9815 2.9272 17.6722 2.39647 17.394C2.12786 17.2532 1.86765 17.0935 1.66701 16.9011C1.46085 16.7033 1.25 16.4034 1.25 16C1.25 15.5966 1.46085 15.2967 1.66701 15.0989C1.86765 14.9065 2.12786 14.7468 2.39647 14.606C2.74813 14.4216 3.20621 14.2237 3.75299 14C3.20621 13.7763 2.74813 13.5784 2.39647 13.394C2.12786 13.2532 1.86765 13.0935 1.66701 12.9011C1.46085 12.7033 1.25 12.4034 1.25 12C1.25 11.5966 1.46085 11.2967 1.66701 11.0989C1.86765 10.9065 2.12786 10.7468 2.39647 10.606C2.74813 10.4216 3.20621 10.2237 3.75299 10C3.20621 9.77632 2.74813 9.57835 2.39647 9.39399C2.12786 9.25317 1.86765 9.09352 1.66701 8.90106C1.46085 8.70332 1.25 8.40342 1.25 8C1.25 7.59658 1.46085 7.29668 1.66701 7.09894C1.86765 6.90648 2.12786 6.74683 2.39647 6.60601C2.92721 6.32776 3.70037 6.01851 4.65496 5.63669L7.50875 4.49517C7.54763 4.47962 7.58618 4.4642 7.62442 4.4489ZM5.76613 10.8078L5.25737 11.0113C4.24694 11.4154 3.54677 11.6966 3.09295 11.9345C3.0486 11.9578 3.00863 11.9796 2.97268 12C3.00863 12.0204 3.0486 12.0422 3.09295 12.0655C3.54677 12.3034 4.24694 12.5845 5.25737 12.9887L8.06584 14.1121C10.0907 14.922 10.9396 15.25 12 15.25C13.0604 15.25 13.9093 14.922 15.9342 14.1121L18.7426 12.9887C19.7531 12.5845 20.4532 12.3034 20.9071 12.0655C20.9514 12.0422 20.9914 12.0204 21.0273 12C20.9914 11.9796 20.9514 11.9578 20.9071 11.9345C20.4532 11.6966 19.7531 11.4154 18.7426 11.0113L18.2339 10.8078L16.4912 11.5048C16.4524 11.5204 16.4138 11.5358 16.3756 11.5511C14.4988 12.302 13.3792 12.75 12 12.75C10.6208 12.75 9.50121 12.302 7.62443 11.5511C7.58619 11.5358 7.54763 11.5204 7.50875 11.5048L5.76613 10.8078ZM5.76613 14.8078L5.25737 15.0113C4.24694 15.4154 3.54678 15.6966 3.09295 15.9345C3.0486 15.9578 3.00863 15.9796 2.97268 16C3.00863 16.0204 3.0486 16.0422 3.09295 16.0655C3.54677 16.3034 4.24694 16.5845 5.25737 16.9887L8.06584 18.1121C10.0907 18.922 10.9396 19.25 12 19.25C13.0604 19.25 13.9093 18.922 15.9342 18.1121L18.7426 16.9887C19.7531 16.5845 20.4532 16.3034 20.9071 16.0655C20.9514 16.0422 20.9914 16.0204 21.0273 16C20.9914 15.9796 20.9514 15.9578 20.9071 15.9345C20.4532 15.6966 19.7531 15.4154 18.7426 15.0113L18.2339 14.8078L16.4912 15.5048C16.4524 15.5204 16.4138 15.5358 16.3756 15.5511C14.4988 16.302 13.3792 16.75 12 16.75C10.6208 16.75 9.50121 16.302 7.62443 15.5511C7.58619 15.5358 7.54763 15.5204 7.50875 15.5048L5.76613 14.8078Z"/>';
        }
        // Update label back
        const label = btn.querySelector('.bb-label');
        if (label) {
          label.textContent = 'Add to set';
        }
        if (removeBtn) {
          removeBtn.classList.remove('bb-visible');
          removeBtn.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }

  // Add product to set (called when clicking Add to Set button)
  function addProductToSet(product) {
    if (!product || !product.id) return;
    if (state.items.length >= MAX_ITEMS) {
      showError(`You can add up to ${MAX_ITEMS} items to a set.`);
      openModal(); // show message if there are items
      return;
    }
    // prevent duplicates
    if (state.items.some(i => String(i.id) === String(product.id))) {
      // keep collapsed; user can expand via toggle
      return;
    }
    product.price = Number(product.price) || 0;
    // Insert with placeholder image fields to render immediately
    state.items.push({ ...product, image: product.image || null, imageAlt: product.imageAlt || '' });
    saveToStorage();
    // keep collapsed by default; update count on the toggle
    updateToggleLabel();
    updateBackdropVisibility();
  updateToggleVisibility();
    updateButtonStates();

    // Enrich with thumbnail asynchronously
    fetchProductThumb(product.url).then(({ src, alt }) => {
      if (!src) return;
      const item = state.items.find(i => String(i.id) === String(product.id));
      if (!item) return;
      item.image = src;
      item.imageAlt = alt || item.title;
      saveToStorage();
      // If overlay is open, re-render to show images
      const overlay = document.getElementById('bb-overlay');
      if (overlay && !overlay.classList.contains('bb-hidden')) renderList();
    });
  }

  // Event handler: add selected items to cart (sequentially)
  async function onAddToCart() {
    clearError();
    if (state.items.length === 0) {
      showError('Your set is empty. Add some items first.');
      return;
    }

  const initialCount = state.items.length;

    const addBtn = document.getElementById('bb-add-cart');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
    }

    try {
      for (const it of state.items) {
        const productJsonUrl = (it.url || '').replace(/\/$/, '') + '.js';
        const resp = await fetch(productJsonUrl, { credentials: 'same-origin' });
        if (!resp.ok) throw new Error(`Failed to fetch data for "${it.title}".`);
        const prod = await resp.json();
        const variantId = (prod && prod.variants && prod.variants[0] && prod.variants[0].id) || null;
        if (!variantId) throw new Error(`No purchasable variant found for "${it.title}".`);

        const addResp = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!addResp.ok) {
          const txt = await addResp.text();
          throw new Error(`Could not add "${it.title}" to cart. ${txt || ''}`);
        }
        await new Promise(res => setTimeout(res, 150));
      }

      const productIds = state.items.map(i => i.id).join(',');
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { bundle_build: productIds } })
      });

      // success: clear set from memory and storage
      // Choose discount redirect based on item count
      let redirectUrl = '/cart';
      if (initialCount >= 5 && DISCOUNT_5_ITEMS) {
        redirectUrl = `/discount/${encodeURIComponent(DISCOUNT_5_ITEMS)}?redirect=/cart`;
      } else if (initialCount >= 3 && DISCOUNT_3_ITEMS) {
        redirectUrl = `/discount/${encodeURIComponent(DISCOUNT_3_ITEMS)}?redirect=/cart`;
      }

      state.items = [];
      clearStorage();

      window.location.href = redirectUrl;
    } catch (err) {
      console.error('bundle-builder error:', err);
      showError('There was an issue adding your set to the cart. Please try again.');
    } finally {
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart';
      }
      renderList();
    }
  }

  // Delegated listener for Add to Set buttons
  function installButtonListener() {
    document.body.addEventListener('click', function (e) {
      const removeBtn = e.target.closest && e.target.closest('.bb-remove-inline');
      if (removeBtn) {
        e.preventDefault();
        removeProductFromSet(removeBtn.getAttribute('data-product-id'));
        return;
      }
      const btn = e.target.closest && e.target.closest('.btn--add-to-set');
      if (!btn) return;
      e.preventDefault();

      if (btn.classList.contains('bb-added')) {
        removeProductFromSet(btn.getAttribute('data-product-id'));
        return;
      }

      const product = {
        id: btn.getAttribute('data-product-id'),
        title: btn.getAttribute('data-product-title') || btn.getAttribute('data-product-name') || 'Product',
        url: btn.getAttribute('data-product-url') || btn.getAttribute('data-product-href') || '#',
        price: parseFloat(btn.getAttribute('data-product-price') || btn.getAttribute('data-product-price-number') || '0')
      };

      addProductToSet(product);
    }, false);
  }

  // Site-wide injector: add button to any eligible product card
  function sitewideInject(container) {
    if (!container) return;
  const ICON_SVG = '<svg class="bb-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4.75C10.9396 4.75 10.0907 5.07796 8.06584 5.88789L5.25737 7.01128C4.24694 7.41545 3.54677 7.69659 3.09295 7.93451C3.0486 7.95776 3.00863 7.97959 2.97267 8C3.00863 8.02041 3.0486 8.04224 3.09295 8.06549C3.54677 8.30341 4.24694 8.58455 5.25737 8.98872L8.06584 10.1121C10.0907 10.922 10.9396 11.25 12 11.25C13.0604 11.25 13.9093 10.922 15.9342 10.1121L18.7426 8.98872C19.7531 8.58455 20.4532 8.30341 20.9071 8.06549C20.9514 8.04224 20.9914 8.02041 21.0273 8C20.9914 7.97959 20.9514 7.95776 20.9071 7.93451C20.4532 7.69659 19.7531 7.41545 18.7426 7.01128L15.9342 5.88789C13.9093 5.07796 13.0604 4.75 12 4.75ZM7.62442 4.4489C9.50121 3.69796 10.6208 3.25 12 3.25C13.3792 3.25 14.4988 3.69796 16.3756 4.4489C16.4138 4.4642 16.4524 4.47962 16.4912 4.49517L19.3451 5.6367C20.2996 6.01851 21.0728 6.32776 21.6035 6.60601C21.8721 6.74683 22.1323 6.90648 22.333 7.09894C22.5392 7.29668 22.75 7.59658 22.75 8C22.75 8.40342 22.5392 8.70332 22.333 8.90106C22.1323 9.09352 21.8721 9.25317 21.6035 9.39399C21.2519 9.57835 20.7938 9.77632 20.247 10C20.7938 10.2237 21.2519 10.4216 21.6035 10.606C21.8721 10.7468 22.1323 10.9065 22.333 11.0989C22.5392 11.2967 22.75 11.5966 22.75 12C22.75 12.4034 22.5392 12.7033 22.333 12.9011C22.1323 13.0935 21.8721 13.2532 21.6035 13.394C21.2519 13.5784 20.7938 13.7763 20.247 14C20.7938 14.2237 21.2519 14.4216 21.6035 14.606C21.8721 14.7468 22.1323 14.9065 22.333 15.0989C22.5392 15.2967 22.75 15.5966 22.75 16C22.75 16.4034 22.5392 16.7033 22.333 16.9011C22.1323 17.0935 21.8721 17.2532 21.6035 17.394C21.0728 17.6722 20.2997 17.9815 19.3451 18.3633L16.4912 19.5048C16.4524 19.5204 16.4138 19.5358 16.3756 19.5511C14.4988 20.302 13.3792 20.75 12 20.75C10.6208 20.75 9.50121 20.302 7.62443 19.5511C7.58619 19.5358 7.54763 19.5204 7.50875 19.5048L4.6549 18.3633C3.70034 17.9815 2.9272 17.6722 2.39647 17.394C2.12786 17.2532 1.86765 17.0935 1.66701 16.9011C1.46085 16.7033 1.25 16.4034 1.25 16C1.25 15.5966 1.46085 15.2967 1.66701 15.0989C1.86765 14.9065 2.12786 14.7468 2.39647 14.606C2.74813 14.4216 3.20621 14.2237 3.75299 14C3.20621 13.7763 2.74813 13.5784 2.39647 13.394C2.12786 13.2532 1.86765 13.0935 1.66701 12.9011C1.46085 12.7033 1.25 12.4034 1.25 12C1.25 11.5966 1.46085 11.2967 1.66701 11.0989C1.86765 10.9065 2.12786 10.7468 2.39647 10.606C2.74813 10.4216 3.20621 10.2237 3.75299 10C3.20621 9.77632 2.74813 9.57835 2.39647 9.39399C2.12786 9.25317 1.86765 9.09352 1.66701 8.90106C1.46085 8.70332 1.25 8.40342 1.25 8C1.25 7.59658 1.46085 7.29668 1.66701 7.09894C1.86765 6.90648 2.12786 6.74683 2.39647 6.60601C2.92721 6.32776 3.70037 6.01851 4.65496 5.63669L7.50875 4.49517C7.54763 4.47962 7.58618 4.4642 7.62442 4.4489ZM5.76613 10.8078L5.25737 11.0113C4.24694 11.4154 3.54677 11.6966 3.09295 11.9345C3.0486 11.9578 3.00863 11.9796 2.97268 12C3.00863 12.0204 3.0486 12.0422 3.09295 12.0655C3.54677 12.3034 4.24694 12.5845 5.25737 12.9887L8.06584 14.1121C10.0907 14.922 10.9396 15.25 12 15.25C13.0604 15.25 13.9093 14.922 15.9342 14.1121L18.7426 12.9887C19.7531 12.5845 20.4532 12.3034 20.9071 12.0655C20.9514 12.0422 20.9914 12.0204 21.0273 12C20.9914 11.9796 20.9514 11.9578 20.9071 11.9345C20.4532 11.6966 19.7531 11.4154 18.7426 11.0113L18.2339 10.8078L16.4912 11.5048C16.4524 11.5204 16.4138 11.5358 16.3756 11.5511C14.4988 12.302 13.3792 12.75 12 12.75C10.6208 12.75 9.50121 12.302 7.62443 11.5511C7.58619 11.5358 7.54763 11.5204 7.50875 11.5048L5.76613 10.8078ZM5.76613 14.8078L5.25737 15.0113C4.24694 15.4154 3.54678 15.6966 3.09295 15.9345C3.0486 15.9578 3.00863 15.9796 2.97268 16C3.00863 16.0204 3.0486 16.0422 3.09295 16.0655C3.54677 16.3034 4.24694 16.5845 5.25737 16.9887L8.06584 18.1121C10.0907 18.922 10.9396 19.25 12 19.25C13.0604 19.25 13.9093 18.922 15.9342 18.1121L18.7426 16.9887C19.7531 16.5845 20.4532 16.3034 20.9071 16.0655C20.9514 16.0422 20.9914 16.0204 21.0273 16C20.9914 15.9796 20.9514 15.9578 20.9071 15.9345C20.4532 15.6966 19.7531 15.4154 18.7426 15.0113L18.2339 14.8078L16.4912 15.5048C16.4524 15.5204 16.4138 15.5358 16.3756 15.5511C14.4988 16.302 13.3792 16.75 12 16.75C10.6208 16.75 9.50121 16.302 7.62443 15.5511C7.58619 15.5358 7.54763 15.5204 7.50875 15.5048L5.76613 14.8078Z"/></svg>';
  const REMOVE_ICON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    const selectors = [
      'li.collection-product-card',
      '.products-slider__slide',
      '.card-wrapper', '.product-card', '.card'
    ];
    const candidates = container.querySelectorAll(selectors.join(','));
    candidates.forEach(card => {
      if (!card.hasAttribute('data-bb-eligible')) return;
      // Skip nested eligible elements; only inject on the top-most eligible container
      const topEligible = card.closest('[data-bb-eligible]');
      if (topEligible && topEligible !== card) return;
      if (card.getAttribute('data-bb-injected') === '1') return;
      const pid = card.getAttribute('data-product-id');
      const title = card.getAttribute('data-product-title') || 'Product';
      const url = card.getAttribute('data-product-url') || '#';
      const price = card.getAttribute('data-product-price-number') || '0';
      if (!pid) return;
      // Prefer to place under the title/price block when available
      const infoTarget = card.querySelector('.card-information .card-information__wrapper .card-information-block')
                        || card.querySelector('.card-information')
                        || card;
      // If a button is already present at the target, mark injected and skip
      const existingBtn = infoTarget.querySelector('.btn--add-to-set');
      if (existingBtn) {
        card.setAttribute('data-bb-injected', '1');
        let controls = existingBtn.closest('.bb-card-controls');
        if (!controls) {
          controls = document.createElement('div');
          controls.className = 'bb-card-controls';
          existingBtn.parentNode.insertBefore(controls, existingBtn);
          controls.appendChild(existingBtn);
        }
        if (!controls.querySelector('.bb-remove-inline')) {
          const removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'bb-remove-inline';
          removeBtn.setAttribute('aria-label', 'Remove ' + title + ' from set');
          removeBtn.setAttribute('data-product-id', pid);
          removeBtn.setAttribute('aria-hidden', 'true');
          removeBtn.innerHTML = REMOVE_ICON_SVG;
          controls.appendChild(removeBtn);
        }
        return;
      }
       const controls = document.createElement('div');
       controls.className = 'bb-card-controls';

       const btn = document.createElement('button');
       btn.type = 'button';
       btn.className = 'btn--add-to-set';
       btn.setAttribute('aria-label', 'Add ' + title + ' to set');
       btn.setAttribute('data-product-id', pid);
       btn.setAttribute('data-product-title', title);
       btn.setAttribute('data-product-url', url);
       btn.setAttribute('data-product-price', price);
       btn.setAttribute('data-product-price-number', price);
       btn.innerHTML = ICON_SVG + '<span class="bb-label">Add to set</span>';

       const removeBtn = document.createElement('button');
       removeBtn.type = 'button';
       removeBtn.className = 'bb-remove-inline';
       removeBtn.setAttribute('aria-label', 'Remove ' + title + ' from set');
       removeBtn.setAttribute('data-product-id', pid);
  removeBtn.setAttribute('aria-hidden', 'true');
       removeBtn.innerHTML = REMOVE_ICON_SVG;

       controls.appendChild(btn);
       controls.appendChild(removeBtn);

       infoTarget.appendChild(controls);
       card.setAttribute('data-bb-injected', '1');
     });
   }

  // Initialize on DOM ready
  function init() {
    // load persisted items
    state.items = loadFromStorage();

    if (!getRoot()) {
      console.warn('bundle-builder: #bundle-builder-root not found. Modal will not render until you add <div id="bundle-builder-root"></div> in layout.');
    } else {
      ensureModal();
      // Start collapsed; just sync counts
      updateToggleLabel();
      updateToggleVisibility();
    }

    const syncCartDrawer = () => setBundleHiddenByCart(document.body && document.body.classList.contains('overflow-hidden-drawer'));
    if (document.body) {
      if (!cartDrawerObserver) {
        cartDrawerObserver = new MutationObserver(syncCartDrawer);
        cartDrawerObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }
      syncCartDrawer();
    }
    installButtonListener();
    
    // Update button states after initial load and injection
    setTimeout(() => updateButtonStates(), 100);

    // Site-wide injector boot
    sitewideInject(document);
    const mo = new MutationObserver(muts => {
      for (const m of muts) {
        if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach(n => { if (n.nodeType === 1) sitewideInject(n); });
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => sitewideInject(document));
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(init, 0);
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();